.ba{flex-wrap:wrap;}